module.exports = __webpack_public_path__ + "img/phone.29065770.png";